import {CompanyReportScreen} from "./ProductsReports.jsx";
export default function InvoiceReports(){return <CompanyReportScreen kind="invoices"/>;}
